/**
 * ShelfAccordionCtrl controller
 * Handles the accordion functionality for content shelves
 */
/* @ngInject */

export default function ShelfAccordionCtrl (
  $scope,
  $uibModal,
  Shelf
  // subscriptions
) {
  const vm = this

  vm.parent = $scope.$parent.vm
  vm.parentScope = $scope.$parent

  // Get data from parent scope
  vm.shelf = $scope.$parent.shelf

  vm.shelf.$autoIdentifier = !vm.shelf.identifier

  vm.validationObject = { valid: true, dirty: false, shelf: vm.shelf }

  vm.parent.shelvesValidation.push(vm.validationObject)

  vm.contentShelfTypes = vm.parent.contentShelfTypes

  vm.contentType = $scope.$parent.contentType

  /**
   * Delete a shelf
   * @param {Object} shelf - The shelf to delete
   * @param {number} index - The index of the shelf in the array
   * @param form
   */
  vm.deleteShelf = function (shelf, index, form) {
    form.$setDirty()
    if (shelf.$action === 'create') {
      vm.parentScope.vm.shelves[shelf.contentType].splice(index, 1)
      const indexInValidation = vm.parent.shelvesValidation
        .findIndex(i => i.shelf.$$hashKey === shelf.$$hashKey)
      vm.parent.shelvesValidation.splice(indexInValidation, 1)
    } else {
      shelf.$action = 'delete'
    }

    vm.validateShelves()
  }

  /**
   * Add a slot to a shelf
   * @param {Object} shelf - The shelf to add slot to
   * @param {Object} form - The form object
   */
  vm.addSlot = function (shelf, form) {
    const initialItems = angular.copy(shelf.slots || [])

    $uibModal.open({
      templateUrl: 'components/packages/components/shelves/addSlots.html',
      controller: 'AddSlotsCtrl as vm',
      animation: false,
      size: 'xl',
      resolve: {
        contentType: function () { return vm.contentShelfTypes[shelf.contentType] },
        shelf: function () { return shelf },
        contentItems: function () { return shelf.slots },
        subscriptions: function () { return vm.parent.subscriptions },
        packgId: function () { return vm.parent.pckg.id }
      }
    })
      .result
      .then(
        function close (contentItems) {
          shelf.slots = angular.copy(contentItems)
          form.$setDirty()
        },
        function dismiss () {
          angular.copy(initialItems, shelf.slots)
        })
  }

  /**
   * Delete a slot from a shelf
   * @param {Object} shelf - The shelf containing the slot
   * @param {Object} slot - The slot to delete
   * @param {number} index - The index of the slot
   */
  vm.deleteSlot = function (shelf, slot, index, form) {
    form.$setDirty()
    shelf.slots.splice(index, 1)
  }

  /**
   * Check if the form is disabled
   * @returns {boolean} - Whether the form should be disabled
   */
  vm.isDisabled = function () {
    return false // Override this in the parent controller if needed
  }

  /**
   * Show error for banner carousel item
   * @param {Object} slot - The slot to check for errors
   * @returns {boolean} - Whether to show error
   */
  vm.showBCItemError = function (slot) {
    return false // Override this in the parent controller if needed
  }

  /**
   * Get selected items for drag and drop
   * @param {Array} list - The list of items
   * @param {Object} item - The selected item
   * @returns {Array} - Array of selected items
   */
  vm.getSelected = function (list, item) {
    item.selected = true
    return list.filter(i => i.selected)
  }

  /**
   * Handle drag start event
   * @param {Array} list - The list being dragged
   * @param {Event} event - The drag event
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      // Use a default drag image if available
      const dragndropImg = new window.Image()
      dragndropImg.src = require('../../img/dragndrop.png')
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * Handle moved items in drag and drop
   * @param {Array} list - The list of items
   */
  vm.onMoved = function (list) {
    // Remove selected items from the list
    for (let i = list.length - 1; i >= 0; i--) {
      if (list[i].selected) {
        list.splice(i, 1)
      }
    }
  }

  /**
   * Handle drag end event
   * @param {Array} list - The list of items
   */
  vm.onDragend = function (list) {
    list.forEach(item => {
      item.selected = false
    })
    list.dragging = false
  }

  /**
   * Handle drop event
   * @param {Array} list - The target list
   * @param {Array} items - The dropped items
   * @param {number} index - The drop index
   * @param {Object} shelf - The shelf object
   * @param {Object} form - The form object
   * @returns {boolean} - Whether to prevent default insertion
   */
  vm.onDrop = function (list, items, index, shelf, form) {
    if (form && form.$setDirty) form.$setDirty()

    // Ensure items maintain their prototype and methods
    const processedItems = items.map(item => {
      if (item && typeof item === 'object') {
        // If item doesn't have the _previewImageUrl method, try to restore it
        if (!item._previewImageUrl || typeof item._previewImageUrl !== 'function') {
          // Try to find the original item in the list to restore its prototype
          const originalItem = list.find(original =>
            original.id === item.id ||
            original.title === item.title ||
            original === item
          )
          if (originalItem && originalItem._previewImageUrl) {
            Object.setPrototypeOf(item, Object.getPrototypeOf(originalItem))
          }
        }
      }
      return item
    })

    list.splice(index, 0, ...processedItems)
    processedItems.forEach(item => { item.selected = false })
    return true
  }

  vm.clearSlots = function () {
    vm.shelf.slots.length = 0
  }

  vm.validateShelf = function (shelf) {
    return shelf.valid && shelf.shelf.slots.length
  }

  vm.validateShelves = function () {
    vm.parent.scope.updatedShelves = vm.parent.shelvesValidation.every(i => {
      return (i.shelf.$action === 'delete' || vm.validateShelf(i))
    }) // && vm.parent.shelvesValidation.some(i => i.dirty)
  }

  vm.setFormDirty = function () {
    if (vm.shelf.$fromCategory) {
      vm.form.$setDirty()
    }
  }

  $scope.$watch('vm.form.$valid', function (newVal, oldVal) {
    if (oldVal === undefined) return

    vm.validationObject.valid = newVal
    vm.validateShelves()
  })

  $scope.$watch('vm.form.$dirty', function (newVal, oldVal) {
    if (newVal !== true) return
    if (!vm.shelf.$action) {
      vm.shelf.$action = 'update'
    }

    vm.validationObject.dirty = newVal
    vm.validateShelves()
  })

  $scope.$watch('vm.shelf.slots.length', function (newVal, oldVal) {
    if (oldVal === undefined || (newVal === oldVal)) return

    if (!vm.shelf.$action) {
      vm.shelf.$action = 'update'
    }

    vm.validateShelves()
  })
}
